import { render, staticRenderFns } from "./NewBlackList.vue?vue&type=template&id=6cf5bb12&scoped=true"
import script from "./NewBlackList.vue?vue&type=script&lang=js"
export * from "./NewBlackList.vue?vue&type=script&lang=js"
import style0 from "./NewBlackList.vue?vue&type=style&index=0&id=6cf5bb12&prod&lang=scss&scoped=true"
import style1 from "./NewBlackList.vue?vue&type=style&index=1&id=6cf5bb12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf5bb12",
  null
  
)

export default component.exports